import { SxProps, Theme } from '@mui/system';
import { styled } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import { CommonColors } from '@/Themes';

export const appBarStyles: SxProps<Theme> = {
  background: CommonColors.mainBackground,
  color: CommonColors.loblolly,
  boxShadow: 1,
};

export const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));
